import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { ContactFormComponent } from '@app/common/components/contact-form/contact-form.component';

@Component({
  selector: 'app-contact-form-dialog',
  imports: [ContactFormComponent, MatDialogModule],
  templateUrl: './contact-form-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact-form-dialog.component.scss'
})
export class ContactFormDialogComponent {
  private dialogRef = inject<MatDialogRef<ContactFormDialogComponent>>(MatDialogRef);

  closeDialog(): void {
    this.dialogRef.close();
  }
}
